import script from "./CreateProjectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProjectDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateProjectDialog.vue?vue&type=style&index=0&id=f1c2b518&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1c2b518"]])

export default __exports__